import {
  Component,
  computed,
  ElementRef,
  forwardRef,
  inject,
  signal,
  viewChild,
  ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  ControlSystemDto,
  SensorBlockService,
} from '@artemis-software/wr-api';
import { Router } from '@angular/router';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { NbPopoverDirective } from '@nebular/theme';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { loader } from '@/utils/signals/loader';

@Component({
  standalone: false,
  selector: 'wr-control-system-select',
  templateUrl: './control-system-select.component.html',
  styleUrls: ['./control-system-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ControlSystemSelectComponent),
      multi: true,
    },
  ],
})
export class ControlSystemSelectComponent extends AbstractFormControl<ControlSystemDto | undefined> {

  readonly sensorBlockService = inject(SensorBlockService);
  readonly router = inject(Router);
  readonly loading = loader();

  popover = viewChild(NbPopoverDirective);

  @ViewChild('searchInput')
  input?: ElementRef;

  filterText = signal('');

  readonly controlSystems = asyncComputed(() => this.sensorBlockService.findAllControlSystems(), [], this.loading);
  readonly filteredControlSystems = computed(() => {
    const filterText = this.filterText();
    return this.controlSystems()?.filter(cs => cs.name.toLowerCase().includes(filterText.toLowerCase())) || [];
  });

  trackById(index: number, item: ControlSystemDto): string {
    return item.id;
  }

  override writeValue(controlSystem: ControlSystemDto): void {
    super.writeValue(controlSystem);
    this.filterText.set(this.viewHandle(controlSystem));
  }

  onSelectionChange(building?: ControlSystemDto): void {
    if (building?.id) {
      this.filterText.set(this.viewHandle(building));
      this.value = building;
      this.popover()?.hide();
    }
  }

  viewHandle(value?: ControlSystemDto | string): string {
    if (typeof value === 'string') {
      return value;
    }
    if (value) {
      return value.name;
    }
    return '';
  }

  clear(): void {
    this.value = undefined;
    this.filterText.set('');
  }

  protected readonly loader = loader;
}
